import { lazy } from 'react';

// project imports
import GuestGuard from 'utils/route-guard/GuestGuard';
import MinimalLayout from 'layout/MinimalLayout';
import NavMotion from 'layout/NavMotion';
import Loadable from 'ui-component/Loadable';

// login routing
const AuthVerifyMagicLink = Loadable(lazy(() => import('views/pages/authentication/auth-forms/AuthVerifyMagicLink')));

// ==============================|| MAGIC LINK ROUTING ||============================== //

const MagicLinkRoutes = {
    path: '/verify-login',
    element: (
        <NavMotion>
            <GuestGuard>
                <MinimalLayout />
            </GuestGuard>
        </NavMotion>
    ),
    children: [
        {
            path: '/verify-login',
            element: <AuthVerifyMagicLink />
        }
    ]
};

export default MagicLinkRoutes;
